module.exports = __webpack_public_path__ + "img/official_accounts_website_3.c76b9bd3.png";